import { api } from '@/shared/axios-client';
import type { ScmProviderId } from '@/types/scm-provider';

/** Standard auth headers for provider-aware SCM routes. */
export const scmAuthHeaders = (pat: string) => ({
  headers: {
    'Content-Type': 'application/json',
    'Requester-Token': pat,
  },
});

/** Attach the user-selected provider to a POST body. */
export function withScmProvider<T extends object>(
  provider: ScmProviderId,
  body: T,
): T & { provider: ScmProviderId } {
  return { provider, ...body };
}

/** GET helper for SCM discovery routes that take provider as a query param. */
export function scmGet<T>(
  provider: ScmProviderId,
  path: string,
  pat: string,
  params: Record<string, string> = {},
): Promise<T> {
  return api.get(path, {
    params: { provider, ...params },
    ...scmAuthHeaders(pat),
  });
}

/** POST helper for SCM routes. */
export function scmPost<T>(
  provider: ScmProviderId,
  path: string,
  pat: string,
  body: object,
): Promise<T> {
  return api.post(path, withScmProvider(provider, body), scmAuthHeaders(pat));
}
